import {CONFIG} from "@/config";

const Helpers = {
	/**
     * Price formatting helper for any locale and currency combination
     *
     * @param {number} price The price to format
     * @param {number} [digits = 2] Digits after separator to format price with
     *
     * @returns {string} Formatted price taking currency and locale in to account
     */
	toCurrencyString: (price, digits = 2) => {
		const formattedPrice = price.toLocaleString(CONFIG.LOCALE, {
			style: "currency",
			currency: CONFIG.CURRENCY,
			minimumFractionDigits: digits,
			maximumFractionDigits: digits
		});

		return formattedPrice;
	},
	isEmptyObject: function (obj) {
		for (const prop in obj) {
			if (obj.hasOwnProperty(prop)) {
				return false;
			}
		}

		return JSON.stringify(obj) === JSON.stringify({});
	},
	sortObjectByProperty: function (array, property) {
		return Array.from(array)
			.slice()
			.sort((a, b) => a[property] - b[property]);
	},
	/**
	 * Sort properties of object
	 * @param {Object} obj required: Object to sort
	 * @param {String} sortedBy [1]: Key to sort object by. First key by default
	 * @param {Boolean} sortNumeric false: Whether it should sort numeric. Default = alphabetic
	 * @param {Boolean} reverse false: Should output be reversed. Default is not reversed
	 * @param {Boolean} returnObject true: should return object; if false array is returned
	 *
	 * @returns {*} based on returnObject
	 */
	sortProperties: function (obj, sortedBy = 1, sortNumeric = false, reverse = false, returnObject = true) {
		const reversed = reverse ? -1 : 1;
		const sortable = [];
		const newObject = {};

		for (const key in obj) {
			if (obj.hasOwnProperty(key)) {
				sortable.push([key, obj[key]]);
			}
		}
		if (sortNumeric) {
			sortable.sort((a, b) => reversed * (a[1][sortedBy] - b[1][sortedBy]));
		} else {
			sortable.sort((a, b) => {
				const x = a[1][sortedBy].toLowerCase();
				const y = b[1][sortedBy].toLowerCase();
				return x < y ? reversed * -1 : x > y ? reversed : 0;
			});
		}

		for (let i = 0; i < sortable.length; i++) {
			const key = sortable[i][0];
			const value = sortable[i][1];

			newObject[key] = value;
		}

		return returnObject ? newObject : sortable;
	},
	optimizedResize: function (theCallback) {
		const callbacks = [];
		let running = false;

		// fired on resize event
		function resize () {
			if (!running) {
				running = true;
				setTimeout(runCallbacks, 166);
			}
		}

		// run the actual callbacks
		function runCallbacks () {
			callbacks.forEach(function (callback) {
				callback();
			});

			running = false;
		}

		// adds callback to loop
		function addCallback (callback) {
			if (callback) {
				callbacks.push(callback);
			}
		}

		(function () {
			if (!callbacks.length) {
				window.addEventListener("resize", resize);
			}
			addCallback(theCallback);
		})();
	}
};

Array.prototype.first = function (condition) {
	const first = this[0];

	if (typeof condition === "function") {
		return this.find(condition) || first;
	}

	return first;
};

Array.prototype.last = function (condition) {
	const last = this[this.length - 1];

	if (typeof condition === "function") {
		return this.find(condition) || last;
	}

	return last;
};

export const Helper = Helpers;



// WEBPACK FOOTER //
// ./src/helpers.js